<!-- Notes Section - Start 1/2 width and expands 100% when opened -->
<div 
  class="additional-info-container"
  [class.info-container-expanded]="isOpen"
>
  <button
    class="info-container-header"
    [class.info-header-expanded]="isOpen"
    (click)="toggleContainerOpen()"  
    [attr.aria-label]="!isOpen ? 'Expand for Additional Information' : 'Close Additional Information'"
  >
    <zbp-icon
      aria-hidden="true"
      [iconName]="iconNames.notepadWithT"
    />
  <h2 class="info-title">Additional Info</h2>
    @if(isOpen) {
      <zbp-icon
        [iconName]="iconNames.x_cross"
      />
    }
  </button>
  <div 
    class="info-container"
    [class.is-opened]="isOpen"
  >
    <div
      class="info-content"
      [innerHTML]="asset.additionalInfo"
    >
    </div>
  </div>
</div>
